import { z } from "zod";

const commissionStatuses = ["pending", "payable", "paid", "cancelled"] as const;

export const CommissionSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().nullable().describe("Business"),
  account_id: z.string().uuid().nullable().describe("Account"),
  opportunity_id: z.string().uuid().describe("Opportunity"),
  team_member_role_id: z.string().uuid().describe("Team Member"),
  base_amount: z.number().describe("Base Amount"),
  commission_rate: z.number().describe("Commission Rate"),
  commission_amount: z.number().describe("Commission Amount"),
  bonus_amount: z.number().describe("Bonus Amount"),
  total_amount: z.number().describe("Total Amount"),
  status: z.enum(commissionStatuses).describe("Status"),
  pay_period_start: z.string().nullable().describe("Pay Period Start"),
  pay_period_end: z.string().nullable().describe("Pay Period End"),
  paid_at: z.string().nullable().describe("Paid At"),
  calculation_details: z
    .record(z.unknown())
    .nullable()
    .describe("Calculation Details"),
  custom_fields: z
    .record(z.unknown())
    .nullable()
    .optional()
    .describe("Custom Fields"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
});
export type Commission = z.infer<typeof CommissionSchema>;

const commissionInsertStatuses = [
  "pending",
  "payable",
  "paid",
  "cancelled",
] as const;

export const CommissionInsertSchema = z.object({
  opportunity_id: z.string().uuid().describe("Opportunity"),
  team_member_role_id: z.string().uuid().describe("Team Member"),
  base_amount: z.number().describe("Base Amount"),
  commission_rate: z.number().describe("Commission Rate"),
  commission_amount: z.number().describe("Commission Amount"),
  bonus_amount: z.number().default(0).describe("Bonus Amount"),
  status: z
    .enum(commissionInsertStatuses)
    .default("pending")
    .or(z.literal("").transform(() => undefined))
    .describe("Status"),
  pay_period_start: z
    .string()
    .nullable()
    .optional()
    .describe("Pay Period Start"),
  pay_period_end: z.string().nullable().optional().describe("Pay Period End"),
  paid_at: z.string().nullable().optional().describe("Paid At"),
  calculation_details: z
    .record(z.unknown())
    .nullable()
    .optional()
    .describe("Calculation Details"),
  custom_fields: z
    .record(z.unknown())
    .nullable()
    .optional()
    .describe("Custom Fields"),
});
export type CommissionInsert = z.infer<typeof CommissionInsertSchema>;
